import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function TitleAndParagraph({ data }) {
    return (
        <div key={data.documentId} className="title-and-paragraph">
            <div className="row tp-div background-full-width" style={{}}>
                <div className="container tp-container">
                    <div className="">
                        <div className="center-align" id="tpTitle">
                            <h2 className="section-headline">
                                {data.titleText}
                            </h2>
                        </div>
                        <div className="medium-blue-text center-align" id="">
                            <p className="body-text" align="left" style={{margin: '0 auto', maxWidth: '800px'}}>
                                {data.paragraphText}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TitleAndParagraph;
